import React, { ReactElement } from 'react';
import { YesOrNoStepCreator } from '../../shared/YesOrNoStepCreator/YesOrNoStepCreator';
import { NavigationButtons } from '../../shared/NavigationButtons/NavigationButtons';
import { Formik, Form } from 'formik';
import { CoverageCheckupState, goToNextStep, updateCoverageCheckupState } from '../../../store/step';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { createYesNoObjectSchema } from '../../schema/yesNoNotSureSchema';
import { CardPadding } from '../../shared/CardStyles';
import { CardHeader } from '../../shared/CardStyles/CardHeader';
import { useFormInteractionTracking } from '../../../hooks/useFormInteractionTracking';

function DependentsStep(): ReactElement {
  const dispatch = useDispatch();
  const { dependents: dependents } = useSelector(
    (state: RootState) => state.steps
  );

  const formRef = useFormInteractionTracking('dependents');

  function onSubmit(values: Partial<CoverageCheckupState>): void {
    dispatch(updateCoverageCheckupState(values));
    dispatch(goToNextStep());
  }

  return (
    <CardPadding>
      <CardHeader
        header="Do you have any dependents?"
        subHeader="A dependent is anyone you support financially, like kids under 18, a
        stay-at-home spouse, elderly parents, etc."
      />
      <Formik
        initialValues={{ dependents }}
        onSubmit={onSubmit}
        validationSchema={createYesNoObjectSchema('dependents')}
      >
        <Form ref={formRef}>
          <YesOrNoStepCreator name="dependents" />

          <NavigationButtons />
        </Form>
      </Formik>
    </CardPadding>
  );
}

export { DependentsStep };
